module.exports = __webpack_public_path__ + "static/media/image_aboutus.7326aef3.png";